const HASH_PATTERN = /^[0-9a-f]{64}$/;

export const screeningPublicationIdentity = (generation) => {
  const generationId = String(generation?.generation_id || '');
  const generationHash = String(generation?.generation_hash || '').toLowerCase();
  const profileSchemaVersion = String(generation?.profile_schema_version || '');
  const profileBundleHash = String(generation?.profile_bundle_hash || '').toLowerCase();
  if (
    !generationId
    || !HASH_PATTERN.test(generationHash)
    || !profileSchemaVersion
    || !HASH_PATTERN.test(profileBundleHash)
  ) return null;
  return {
    generationId,
    generationHash,
    profileSchemaVersion,
    profileBundleHash,
  };
};

export const sameScreeningPublication = (left, right) => {
  const a = screeningPublicationIdentity(left);
  const b = screeningPublicationIdentity(right);
  return Boolean(
    a && b
    && a.generationId === b.generationId
    && a.generationHash === b.generationHash
    && a.profileSchemaVersion === b.profileSchemaVersion
    && a.profileBundleHash === b.profileBundleHash
  );
};

export const stockCandidateCacheKey = ({ generation, ...request }) => {
  const publication = screeningPublicationIdentity(generation);
  return JSON.stringify({ ...request, publication });
};
